export default __webpack_public_path__ + "static/media/laneArrow.a763f011.svg";